import { OrganizationVariable } from "../../redux/reducers/organizationVariablesSlice";
import { VariablesForm } from "../VariablesForm";
import { OrganizationSettingsTab } from "./OrganizationSettingTab";

type GlobalVariablesCardProps = {
  variables: OrganizationVariable[];
  isLoading?: boolean;
  onChange: (updatedVariable: Partial<OrganizationVariable>) => void;
  onCreate: (newVariable: { name: string; value: string; masked: boolean }) => void;
  onClickDelete: (id: string) => Promise<void>;
  className?: string;
};

export const GlobalVariablesCard = ({ variables, onChange, onCreate, onClickDelete }: GlobalVariablesCardProps) => {
  return (
    <OrganizationSettingsTab
      title="Global Variables"
      description="Key-value pairs available to every agent via context.variables. Use for shared config like API keys or feature flags."
      count={variables.length}
    >
      <VariablesForm
        variables={variables}
        onChange={onChange}
        onCreate={onCreate}
        onClickDelete={onClickDelete}
      />
    </OrganizationSettingsTab>
  );
};
